import { ItemListadoServiciosHotel } from "../../../services/hotelServicios";
import { CiudadResumida, Sector } from "../../../services/paisesServicios";
import { NuevoAgendamientoHotel } from "../../../services/agendamientosHotelServicios";
import { ServicioTransporte } from "../../../services/transporteServicios";
import { MetodoPago } from "../../../services/ventasServicios";
import { NuevoItemCarritoHotelRequest } from "../../../services/carritoServicios";
import { RespuestaBuscarPropietario } from "../../../services/propietariosServicios";

export interface Model {
  idMascota: string;
  datosPropietario?: RespuestaBuscarPropietario;
  idPropietario: string;
  nombreMascota: string;
  nombresPropietario: string;
  numeroNochesIndividuales: number;
  valorFinalNocheIndividual?: number;
  tarifaNocheIndividual?: ItemListadoServiciosHotel;
  tarifa?: ItemListadoServiciosHotel;
  valorFinalTarifa?: number;
  fechasProgramadas: string[];
  diasSeleccionados: Date[];
  contrataTransporte: boolean;
  ciudadOrigen?: CiudadResumida;
  contrataIda: boolean;
  contrataVuelta: boolean;
  direccionTransporte?: string;
  sectorTransporte?: Sector;
  tarifaIda?: ServicioTransporte;
  valorFinalIda?: number;
  tarifaVuelta?: ServicioTransporte;
  valorFinalVuelta?: number;
  tarifaIdaVuelta?: ServicioTransporte;
  valorFinalIdaVuelta?: number;
  descuento: number;
  total?: number;
  pago?: PagoModel;
  usarTarifasPorTrayecto?: boolean;
}

export interface PagoModel {
  monto: number;
  metodo: MetodoPago;
}

export const defaultModel: Model = {
  idMascota: "",
  idPropietario: "",
  nombreMascota: "",
  nombresPropietario: "",
  fechasProgramadas: [],
  diasSeleccionados: [],
  contrataTransporte: true,
  contrataIda: true,
  contrataVuelta: true,
  numeroNochesIndividuales: 0,
  descuento: 0,
};

const soloContrataTransporteIda = (model: Model): boolean => {
  return (
    model.contrataTransporte &&
    ((model.contrataIda && !model.contrataVuelta) ||
      (model.contrataIda && !model.tarifaIdaVuelta))
  );
};

const soloContrataTransporteVuelta = (model: Model): boolean => {
  return (
    model.contrataTransporte &&
    ((model.contrataVuelta && !model.contrataIda) ||
      (model.contrataVuelta && !model.tarifaIdaVuelta))
  );
};

const soloContrataTransporteIdaVuelta = (model: Model): boolean => {
  return (
    model.contrataTransporte &&
    model.contrataIda &&
    model.contrataVuelta &&
    !!model.tarifaIdaVuelta
  );
};

const crearDatosTarifa = (model: Model) => {
  return model.tarifa
    ? {
        idTarifa: model.tarifa.id,
        precioFinal: model.valorFinalTarifa!!,
      }
    : undefined;
};

const crearDatosNochesIndividuales = (model: Model) => {
  return model.tarifaNocheIndividual
    ? {
        idServicio: model.tarifaNocheIndividual!!.id,
        precioFinal: model.valorFinalNocheIndividual!!,
        nochesIndividuales: model.numeroNochesIndividuales!!,
      }
    : undefined;
};

const crearDatosTransporteVuelta = (model: Model) => {
  return soloContrataTransporteVuelta(model)
    ? {
        idSector: model.sectorTransporte!!.id,
        direccion: model.direccionTransporte!!,
        idTarifa: model.tarifaVuelta!!.id,
        precioFinal: model.valorFinalVuelta!!,
      }
    : undefined;
};

const crearDatosTransporteIda = (model: Model) => {
  return soloContrataTransporteIda(model)
    ? {
        idSector: model.sectorTransporte!!.id,
        direccion: model.direccionTransporte!!,
        idTarifa: model.tarifaIda!!.id,
        precioFinal: model.valorFinalIda!!,
      }
    : undefined;
};

const crearDatosTransporteIdaVuelta = (model: Model) => {
  return soloContrataTransporteIdaVuelta(model)
    ? {
        idSector: model.sectorTransporte!!.id,
        direccion: model.direccionTransporte!!,
        idTarifa: model.tarifaIdaVuelta!!.id,
        precioFinal: model.valorFinalIdaVuelta!!,
      }
    : undefined;
};

export const buildNuevoAgendamiento = (
  model: Model
): NuevoAgendamientoHotel => {
  const datosTarifa = crearDatosTarifa(model);

  const datosNochesIndividuales = crearDatosNochesIndividuales(model);

  const datosTransporteIda = crearDatosTransporteIda(model);

  const datosTransporteVuelta = crearDatosTransporteVuelta(model);

  const datosTransporteIdaVuelta = crearDatosTransporteIdaVuelta(model);

  const datosTransporte = model.contrataTransporte
    ? {
        datosTransporteIda,
        datosTransporteVuelta,
        datosTransporteIdaVuelta,
      }
    : undefined;

  if (model.contrataTransporte && !datosTransporte)
    throw new Error(
      "Se contrata transporte pero no se definieron datos de transporte"
    );

  const datosPago = model.pago
    ? {
        monto: Number(model.pago.monto),
        metodo: model.pago.metodo,
      }
    : undefined;

  const agendamiento: NuevoAgendamientoHotel = {
    idMascota: model.idMascota,
    datosReservaHotel: {
      datosTarifa: datosTarifa,
      datosNochesIndividuales: datosNochesIndividuales,
      fechasProgramadas: model.fechasProgramadas,
    },
    datosTransporte,
    datosPago: datosPago,
    descuento: model.descuento,
  };

  return agendamiento;
};

const crearDatosTransporteIdaCarrito = (model: Model) => {
  return soloContrataTransporteIda(model)
    ? {
        idTarifa: model.tarifaIda!!.id,
        precioFinal: model.valorFinalIda!!,
      }
    : undefined;
};

const crearDatosTransporteVueltaCarrito = (model: Model) => {
  return soloContrataTransporteVuelta(model)
    ? {
        idTarifa: model.tarifaVuelta!!.id,
        precioFinal: model.valorFinalVuelta!!,
      }
    : undefined;
};

const crearDatosTransporteIdaVueltaCarrito = (model: Model) => {
  return soloContrataTransporteIdaVuelta(model)
    ? {
        idTarifa: model.tarifaIdaVuelta!!.id,
        precioFinal: model.valorFinalIdaVuelta!!,
      }
    : undefined;
};

export function buildNuevoItemCarritoHotel(
  model: Model
): NuevoItemCarritoHotelRequest {
  const datosTarifa = crearDatosTarifa(model);

  const datosNochesIndividuales = crearDatosNochesIndividuales(model);

  const datosTransporteIda = crearDatosTransporteIdaCarrito(model);

  const datosTransporteVuelta = crearDatosTransporteVueltaCarrito(model);

  const datosTransporteIdaVuelta = crearDatosTransporteIdaVueltaCarrito(model);

  const datosTransporte = model.contrataTransporte
    ? {
        fechas: model.fechasProgramadas,
        idSector: model.sectorTransporte!!.id,
        direccion: model.direccionTransporte!!,
        datosIda: datosTransporteIda,
        datosVuelta: datosTransporteVuelta,
        datosIdaVuelta: datosTransporteIdaVuelta,
      }
    : undefined;

  if (model.contrataTransporte && !datosTransporte)
    throw new Error(
      "Se contrata transporte pero no se definieron datos de transporte"
    );

  return {
    idPropietario: model.idPropietario,
    tipoServicio: "HOTEL",
    idMascota: model.idMascota,
    datosReserva: {
      fechasProgramadas: model.fechasProgramadas,
      datosTarifa,
      datosNochesIndividuales,
    },
    datosTransporte,
  };
}
